export default "__VITE_ASSET__Dl98nnUW__"